import { render, staticRenderFns } from "./ShowingTotalText.vue?vue&type=template&id=0c74f6e6"
import script from "./ShowingTotalText.vue?vue&type=script&lang=js"
export * from "./ShowingTotalText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports